import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useSelector, useDispatch } from 'react-redux';
import { EMPTY_ARRAY } from '../../constants';
import { getRequest } from '../../services';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../../amchome/components/header.css';
import '../../../amchome/components/home-body.css';
import '../../../amchome/components/responsive.css';
import RoutesComponent from './Routes';
import STORAGE_KEY from '../../constants/storageKey';
import Loader from '../../components/loader';
import CookiesPolicy from '../../components/cookiesPolicy';
import {
  getGoogleConstants,
  GOOGLE_CONSTANTS,
} from '../../formatter/google.bootstrap';
import { showSnackBar, hideSnackBar } from '../../../redux/snackBarSlice';
import ErrorSnackBar from '../../components/snackBar/ErrorSnackBar';

const LoginDialog = lazy(() => import('../loginDialog'));

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { snackbars } = useSelector((state) => state.globalSnackbar);
  const showLoginDialog = useSelector((state) => state.user.showLoginDialog);
  const dispatch = useDispatch();

  const getBootstrapData = async () => {
    try {
      const res = await getRequest('/common/bootstrap');
      if (res) {
        sessionStorage.setItem(STORAGE_KEY.BOOTSTRAP, JSON.stringify(res));
        setIsLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          message: error.message || 'Failed to load bootstrap data.',
          severity: 'error',
        })
      );
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchDataAndInitGA = async () => {
      await getBootstrapData();
      const GOOGLE_ANALYTICS_TRACKING_ID = getGoogleConstants(
        GOOGLE_CONSTANTS.ANALYTICS
      );
      ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
    };
    fetchDataAndInitGA();
  }, EMPTY_ARRAY);

  const handleClose = (snackbarId, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(hideSnackBar(snackbarId));
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <RoutesComponent />
      <CookiesPolicy />
      <ErrorSnackBar opensnackbar={snackbars} handleClose={handleClose} />
      <Router>
        {showLoginDialog && (
          <Suspense fallback={<Loader />}>
            <LoginDialog />
          </Suspense>
        )}
      </Router>
    </>
  );
}
export default App;
